/*
 * Category directory page (sections/main-categories.liquid).
 *
 * The top sub categories per category are server-rendered into
 * snippets/category-tree.liquid so crawlers see them. This only handles the
 * long tail: "Show all N types" pulls the full custom.sub_type facet for that
 * Product Type out of Algolia and appends whatever isn't already listed.
 */
(function () {
  var cfg = window.AlgoliaConfig;
  var tree = document.querySelector('[data-category-tree]');
  if (!cfg || !cfg.appId || !tree) return;

  var SEARCH_URL = cfg.searchUrl || '/search';

  var STR = { loading: 'Loading…' };
  var strEl = document.querySelector('[data-categories-strings]');
  if (strEl) {
    try { STR = Object.assign(STR, JSON.parse(strEl.textContent)); } catch (e) {}
  }

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Spaces are %20, never + : Shopify's robots.txt disallows /collections/*+*.
  // Prefer the card's own collection URL (crawlable) over the search fallback.
  function groupUrl(category, subType, baseUrl) {
    if (baseUrl && baseUrl.indexOf('/collections/') === 0) {
      return baseUrl + '?type=' + encodeURIComponent(subType);
    }
    var url = SEARCH_URL + '?category=' + encodeURIComponent(category);
    if (subType) url += '&type=' + encodeURIComponent(subType);
    return url;
  }

  function fetchSubTypes(category) {
    return fetch(
      'https://' + cfg.appId + '-dsn.algolia.net/1/indexes/' +
        encodeURIComponent(cfg.index) + '/query',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Algolia-Application-Id': cfg.appId,
          'X-Algolia-API-Key': cfg.apiKey
        },
        body: JSON.stringify({
          query: '',
          hitsPerPage: 0,
          facets: ['meta.custom.sub_type'],
          maxValuesPerFacet: 1000,
          facetFilters: [['product_type:' + category]]
        })
      }
    )
      .then(function (r) {
        if (!r.ok) throw new Error('Algolia ' + r.status);
        return r.json();
      })
      .then(function (res) {
        var facets = (res.facets && res.facets['meta.custom.sub_type']) || {};
        return Object.keys(facets)
          .map(function (name) { return { name: name, count: facets[name] }; })
          .filter(function (s) {
            // Same placeholder rules as scripts/build-category-tree.py
            return s.name !== category;
          })
          .sort(function (a, b) { return b.count - a.count || a.name.localeCompare(b.name); });
      });
  }

  tree.addEventListener('click', function (event) {
    var button = event.target.closest('[data-category-more]');
    if (!button || button.disabled) return;

    var card = button.closest('[data-category-card]');
    var category = card && card.getAttribute('data-category');
    if (!category) return;
    var headLink = card.querySelector('.category-tree__head');
    var baseUrl = headLink ? headLink.getAttribute('href') : '';

    var list = card.querySelector('[data-category-subs]');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'category-tree__subs';
      list.setAttribute('data-category-subs', '');
      card.insertBefore(list, button);
    }

    var original = button.textContent;
    button.disabled = true;
    button.textContent = STR.loading;

    fetchSubTypes(category)
      .then(function (subs) {
        var seen = {};
        list.querySelectorAll('span').forEach(function (el) { seen[el.textContent] = true; });

        var html = subs
          .filter(function (s) { return !seen[s.name]; })
          .map(function (s) {
            return '<li><a href="' + esc(groupUrl(category, s.name, baseUrl)) + '">' +
              '<span>' + esc(s.name) + '</span> ' +
              '<em>' + s.count.toLocaleString() + '</em></a></li>';
          })
          .join('');

        list.insertAdjacentHTML('beforeend', html);
        button.remove();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = original;
      });
  });
})();
